import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { pluralize } from "@common/helpers/string";

interface Props {
    filters: FiltersTypes;
}

const OPERATOR_LABELS: Record<string, string> = {
    gt: ">",
    lt: "<",
    eq: "=",
    between: "between",
};

export const DaysInStageFilterLabel: React.FC<Props> = ({ filters }) => {
    const { daysInStageOperator, daysInStageMin, daysInStageMax } = filters;

    if (!daysInStageOperator || daysInStageMin === undefined) {
        return null;
    }

    const op = OPERATOR_LABELS[daysInStageOperator] ?? daysInStageOperator;

    if (daysInStageOperator === "between" && daysInStageMax !== undefined) {
        return (
            <span>
                {daysInStageMin} – {daysInStageMax}{" "}
                {pluralize("day", daysInStageMax)}
            </span>
        );
    }

    return (
        <span>
            {op} {daysInStageMin} {pluralize("day", daysInStageMin)}
        </span>
    );
};
